import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { FavouritesProvider } from './context/FavouritesContext';
import { Toaster } from 'sonner';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import ProtectedRoute from './components/layout/ProtectedRoute';
import WhatsAppWidget from './components/layout/WhatsAppWidget';
import HomePage from './pages/HomePage';
import PlansPage from './pages/PlansPage';
import PlanDetailsPage from './pages/PlanDetailsPage';
import AuthPage from './pages/AuthPage';
import AuthCallback from './pages/AuthCallback';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import OrderResultPage from './pages/OrderResultPage';
import OrdersPage from './pages/OrdersPage';
import FavouritesPage from './pages/FavouritesPage';
import DashboardPage from './pages/DashboardPage';
import AdminPage from './pages/AdminPage';
import CategoryPage from './pages/CategoryPage';
import { SEO_CATEGORIES } from './lib/seoCategories';
import { initGA, initMetaPixel, trackPageView } from './lib/analytics';
import './App.css';

function AppRouter() {
  const location = useLocation();

  useEffect(() => {
    initGA();
    initMetaPixel();
    trackPageView(location.pathname + location.search);
  }, [location]);

  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <>
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/plans" element={<PlansPage />} />
          <Route path="/plans/:ref" element={<PlanDetailsPage />} />
          <Route path="/login" element={<AuthPage />} />
          
          {/* SEO Category Landing Pages */}
          {SEO_CATEGORIES.map(cat => (
            <Route key={cat.slug} path={`/${cat.slug}`} element={<CategoryPage category={cat} />} />
          ))}
          
          {/* Protected Routes */}
          <Route path="/cart" element={<ProtectedRoute><CartPage /></ProtectedRoute>} />
          <Route path="/checkout" element={<ProtectedRoute><CheckoutPage /></ProtectedRoute>} />
          <Route path="/order-result/:orderId" element={<ProtectedRoute><OrderResultPage /></ProtectedRoute>} />
          <Route path="/orders" element={<ProtectedRoute><OrdersPage /></ProtectedRoute>} />
          <Route path="/favourites" element={<ProtectedRoute><FavouritesPage /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute adminOnly={true}><AdminPage /></ProtectedRoute>} />
          
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppWidget />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen flex flex-col bg-background">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <FavouritesProvider>
              <AppRouter />
              <Toaster 
                position="top-right" 
                toastOptions={{ style: { fontFamily: 'Manrope, sans-serif' } }}
              />
            </FavouritesProvider>
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
